import {Field} from 'formik'
import {useIntl} from 'react-intl'

import {
  CustomSelect,
} from '@/components/form'

const initialFilters = {
}

const statuses = [
  'STATUS_APPROVED',
  'STATUS_PENDING',
  'STATUS_REJECTED',
]

const FilterForm = () => {
  const intl = useIntl()
  return (
    <>
      <Field
        default="Select status"
        component={CustomSelect}
        label="Status"
        name="status"
        options={statuses.map((s:string) => {
          return { value: s, label: intl.formatMessage({id: `P2C.SPONSORSHIP_${s}`})}
        })}
      />
    </>
  )
}

export {FilterForm, initialFilters}
